/** @format */

import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import img1 from '../../images/main/img1.png';
import img2 from '../../images/main/img2.png';
import img3 from '../../images/main/img3.png';
import { SectionHeading as HeadingTitle } from '../misc/Headings.js';
import { PrimaryAction } from 'components/hero/BackgroundAsImage';

const Container = tw.div`relative mx-0 mt-8`;
const SingleColumn = tw.div` mx-auto `;
const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const Content = tw.div`mt-10`;
const Card = styled.div(props => [
	tw`mt-16 md:flex justify-evenly items-center`,
	props.reversed ? tw`flex-row-reverse` : 'flex-row',
]);
const Image = styled.div(props => [
	`background-image: url("${props.imageSrc}");`,
	tw`rounded h-56 md:w-1/12 lg:w-5/12 xl:w-1/3 flex-shrink-0 h-80 md:h-144 bg-contain bg-no-repeat  bg-center mx-4 sm:mx-8 md:mx-4 lg:mx-8`,
]);
const Details = tw.div`mt-4 md:mt-0 md:max-w-md mx-4 sm:mx-8 md:mx-4 lg:mx-8`;
const Title = tw.h4`text-xl font-bold text-darkgreen`;
const Description = tw.p`mt-2 text-lg  font-normal `;

const Feature = () => {
	const cards = [
		{
			imageSrc: `${img1}`,
			title: '1. Get your Free credit review and consulation',
			description:
				"We can't fix somesomething we don't know. Let's start with a professional credit history review. NO obligation. We ger the reports from the three credit agencies and help you understand your practical options.",
		},

		{
			imageSrc: `${img2}`,
			title: '2. We start to work- you can Relax',
			description:
				'Relax while the Renoix credit repair team use the latest credit technology to challange all the negative entries on your behalf. We will write letters, cross-reference public sources, identify mistakes and make sure your credit report is optimized',
		},

		{
			imageSrc: `${img3}`,
			title: '3. Live Better',
			description:
				'As we optimize your credit history and your credit score start to go higher, we will keep you up to date will al recent trends. Having a good credit score is a life-chaning experience, not a hit and go kind of service. We wil;l show you how to keeo your excellent credit score for life',
		},
	];

	return (
		<Container>
			<SingleColumn>
				<HeadingInfoContainer>
					<HeadingTitle>How to Works</HeadingTitle>
				</HeadingInfoContainer>

				<Content>
					{cards.map((card, i) => (
						<Card key={i} reversed={i % 2 === 1}>
							<Image imageSrc={card.imageSrc} />
							<Details>
								<Title>{card.title}</Title>
								<Description>{card.description}</Description>
								<div className="btn-center">
									<a href="#form">
										<PrimaryAction>Get a Free Credit Audit</PrimaryAction>
									</a>
								</div>
							</Details>
						</Card>
					))}
				</Content>
			</SingleColumn>
		</Container>
	);
};

export default Feature;
